'use client';

import {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  createContext,
  useContext,
  useMemo,
  useState,
} from 'react';

interface SignUpContextValue {
  previousCallback?: () => void;
  setPreviousCallback: Dispatch<
    SetStateAction<SignUpContextValue['previousCallback']>
  >;
}

const SignUpContext = createContext<SignUpContextValue>({
  setPreviousCallback: () => () => null,
});

interface SignUpContextProviderProps extends PropsWithChildren {}

const SignUpContextProvider = ({ children }: SignUpContextProviderProps) => {
  const [previousCallback, setPreviousCallback] =
    useState<SignUpContextValue['previousCallback']>();
  const memoizedInitialValue = useMemo(
    () => ({
      previousCallback,
      setPreviousCallback,
    }),
    [previousCallback],
  );

  return (
    <SignUpContext.Provider value={memoizedInitialValue}>
      {children}
    </SignUpContext.Provider>
  );
};

export const useSignUpContext = () => useContext(SignUpContext);

export default SignUpContextProvider;
